<template>
  <div class="main col-xs-12">
    <h3>Accessing restricted resources.</h3>
    <p>You must be <b>authenticated</b> before using this application.</p>
    <p>You will automatically be redirected and logged in. Please wait {{ redirectTimer }} seconds</p>
  </div>
</template>
<script>
  export default {
    name: 'Login',
    data() {
      return {
        redirectTimer: 5,
        timer: null,
      };
    },
    mounted() {
      this.timer = setInterval(() => {
        if (!(--this.redirectTimer)) {
          clearInterval(this.timer);
          window.location = '/login';
        }
      }, 1000);
    },
  };
</script>
